import { useAuth0 } from '@auth0/auth0-react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CreateUser from '../../pages/CreateUser';
import ForgotPasswordWrapper from '../../pages/ForgotPassword';
import Login from '../../pages/Login';
import ResetPasswordWrapper from '../../pages/ResetPassword';
import { parseForwardUrlFromSearch, parseShareIdFromSearch } from './nonAdminAuthUtils';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export function Logout() {
  const { logout } = useAuth0();
  const returnTo = useQuery().get('returnTo') || window.location.origin;

  useEffect(() => {
    logout({ logoutParams: { returnTo: returnTo } });
  }, [logout, returnTo]);

  return <div>Logging out...</div>;
}

export function HandleForwardURL(props: {
  Component: 'Login' | 'CreateUser' | 'ForgotPasswordParamHandler';
}) {
  const forwardUrl = parseForwardUrlFromSearch(window.location.search);
  const componentProps: { forwardUrl?: string } = {};

  if (forwardUrl) {
    componentProps.forwardUrl = forwardUrl;
  }

  switch (props.Component) {
    case 'Login':
      return <Login {...componentProps} />;
    case 'ForgotPasswordParamHandler':
      return <ForgotPasswordParamHandler {...componentProps} />;
    default:
      return null;
  }
}

export function HandleRegisterFromShareURL() {
  parseShareIdFromSearch(window.location.search);
  return <></>;
}

export function ResetPasswordCodeHandler() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oobCode = queryParams.get('oobCode') as string;
  const navigate = useNavigate();

  return <ResetPasswordWrapper code={oobCode} navigate={navigate} />;
}

export function ForgotPasswordParamHandler({ forwardUrl }: { forwardUrl?: string }) {
  const { email } = useParams<{ email?: string }>();
  return <ForgotPasswordWrapper email={email} forwardUrl={forwardUrl} />;
}

export const CreateUserWrapper = () => {
  const { invitationToken } = useParams<{ invitationToken: string }>();
  return <CreateUser invitationToken={invitationToken!} />;
};
